import { Injectable, OnDestroy } from "@angular/core";

import { HttpClient, HttpHeaders } from "@angular/common/http";
import { FirebaseInit } from "../firebase/firebaseinit";
import { LocalDataService } from "../data/localdata/localdataservice";
import { OptionalFirebaseUser } from "../firebase/OptionalFirebaseUser";
import { createMLUserFromFB } from "../webplatform/MLUser";
import { Observable, Subscription, timer } from "rxjs";
import { User } from "firebase/auth";
import { MLLog } from "../../base/lib/logger/Logger";

export interface Listener { (): void };

@Injectable({
    providedIn: 'root'
})
export class WebPlatformAPI {


    static API_KEY_ROTATION_DELAY = 15;

    private portalKey: string | null | undefined = null;
    private available: boolean = false;
    private listeners: Listener[] = [];

    private apiKey: string | null = null;
    private apiKeyError = false;

    private apiKeyRotationSub?: Subscription;

    private static SERVICE_PATH: string;
    private firebaseInit!: FirebaseInit;
    private localService!: LocalDataService;

    private optionalUser!: OptionalFirebaseUser;


    constructor(
        private httpClient: HttpClient,
    ) {
    }

    public setFirebaseInit(firebaseInit: FirebaseInit) {
        this.firebaseInit = firebaseInit;

        this.firebaseInit.f_portal.getLatestKey().subscribe(
            portalKey => {
                this.portalKey = portalKey?.value;
                //MLLog.logDev("Need a portal key?" + portalKey?.value)
                this.available = true;
                for (let listener of this.listeners) {
                    let l: Listener = listener;
                    l();
                }
            }
        );

        this.optionalUser = new OptionalFirebaseUser(this.firebaseInit)
    }
    public setLocalDataService(localDataService: LocalDataService) {
        this.localService = localDataService;
    }

    public static setBasePathService(path: string) {
        WebPlatformAPI.SERVICE_PATH = path;
    }

    public checkAvailability(listener: Listener) {
        if (this.available) {
            listener();
        } else {
            this.listeners.push(listener);
        }
    }

    private getPortalAuthHeaders() {
        return new HttpHeaders({ 'X-Portal-Key': this.key });
    }

    private getUserAuthHeaders() {
        return new HttpHeaders({ 'X-Portal-Key': this.key, 'X-Api-Key': this.getDeviceId() + "-" + this.apiKey as string });
    }

    //DEV STAFF
    public get key() {
        return this.portalKey as string;
    }

    public welcome() {
        this.httpClient.get(WebPlatformAPI.SERVICE_PATH + "/welcome",
            { headers: this.getPortalAuthHeaders(), responseType: "text" },
        ).subscribe(
            (r) => {
                MLLog.logDev("Received")
                MLLog.logDev(r)
            }
        )
    }

    private getDeviceId() {
        return this.localService.deviceId ?? "default00000";
    }

    private invalidateKey() {
        this.apiKey = null;
    }

    private receiveAPIKey(callBack: () => boolean) {
        return {
            next: (data: any) => {
                //MLLog.logDev("Receiving API Key", data.apiKey);
                if (data) {
                    this.apiKey = data.apiKey;
                    this.rescheduleApiKeyRotation();
                    callBack();
                }
            },
            error: (error: any) => {
                this.apiKeyError = true;
                //we reset key if something is wrong
                this.resetKey();
                //MLLog.logError("Api Key Error", error)
            }
        };
    }

    private rescheduleApiKeyRotation() {
        if (this.apiKey != null) {
            //MLLog.logDev("Rescheduling a new API Key")

            const ts12 = this.apiKey.slice(0, 12);
            const m = ts12.match(/^(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})$/);
            if (!m) { return; }

            const base = Date.UTC(2000 + +m[1], +m[2] - 1, +m[3], +m[4], +m[5], +m[6]);
            const delay = base + WebPlatformAPI.API_KEY_ROTATION_DELAY * 60 * 1000 - Date.now();


            this.apiKeyRotationSub?.unsubscribe();
            if (delay <= 0) {
                this.getKey(() => { this.rescheduleApiKeyRotation(); return false; });
                return;
            }
            this.apiKeyRotationSub = timer(delay).subscribe(() => {
                this.invalidateKey();
                //MLLog.logDev("Trying to ask for a new Key Rotation")
                //this.httpClient.get(
                //    WebPlatformAPI.SERVICE_PATH + "/users/rotateKey",
                //    { headers: this.getUserAuthHeaders() }
                //).subscribe(this.receiveAPIKey(() => { return false }));
            });
        }
    }

    private resetKey() {
        this.apiKeyRotationSub?.unsubscribe();
        this.apiKey = null;
    }

    public getKey(callBack: () => boolean) {

        //MLLog.logDev("Request for Key!")


        /*if (this.apiKey != null) {
            this.httpClient.get(
                WebPlatformAPI.SERVICE_PATH + "/users/checkKey",
                { headers: this.getUserAuthHeaders() }
            ).subscribe({
                next: (data: any) => { },
                error: (error: any) => {
                    //if k is no more valid, we expire it and ask for a new one
                    //MLLog.logDev("Resetting API Key")
                    this.apiKeyRotationSub?.unsubscribe();
                    this.apiKey = null;
                }
            });
        }*/

        if (this.apiKey == null) {

            this.optionalUser.getUser().then(

                (user) => {
                    //MLLog.logDev("Device Id " + this.getDeviceId())
                    createMLUserFromFB(user, this.getDeviceId(), "it").then(
                        (mluser) => {
                            this.httpClient.post(
                                WebPlatformAPI.SERVICE_PATH + "/createKey",
                                mluser,
                                { headers: this.getPortalAuthHeaders() }
                            ).subscribe(this.receiveAPIKey(callBack));
                        }
                    );
                }
            )
        } else {
            callBack();
        }

    }

    public checkKey() {

        //MLLog.logDev("Calling Check Key " + this.apiKey)
        if (this.apiKey != null) {
            this.httpClient.get(
                WebPlatformAPI.SERVICE_PATH + "/users/checkKey",
                { headers: this.getUserAuthHeaders() }
            ).subscribe({
                next: (data: any) => {
                    //MLLog.logDev("Key was checked:");
                    //MLLog.logDev(data);
                },
                error: (error: any) => {
                    this.apiKeyError = true;
                    //we reset key if something is wrong
                    this.resetKey();
                    //MLLog.logDev(error)
                }
            });
        }
    }

    public setData(key: string, content: any, ready: () => void, errorFeedback: () => void) {
        //If this.apiKey is null, we need a new api KEY first!

        if (this.apiKey != null) {
            let body = { key: key, content: content };
            this.httpClient.post(
                WebPlatformAPI.SERVICE_PATH + "/users/data/" + key,
                body,
                { headers: this.getUserAuthHeaders() }
            ).subscribe({
                next: (data: any) => {
                    ready();
                },
                error: (error: any) => {
                    this.apiKeyError = true;
                    //we reset key if something is wrong
                    this.resetKey();
                    MLLog.logError("error in Setting Data", error)
                    errorFeedback();
                }
            });
        }
    }

    public getData(key: string, receiver: (data: any) => void) {
        //If this.apiKey is null, we need a new api KEY first!
        if (this.apiKey != null) {
            this.httpClient.get(
                WebPlatformAPI.SERVICE_PATH + "/users/data/" + key,
                { headers: this.getUserAuthHeaders() }
            ).subscribe({
                next: (data: any) => {
                    receiver(data.content);
                },
                error: (error: any) => {
                    this.apiKeyError = true;
                    //we reset key if something is wrong
                    this.resetKey();
                    MLLog.logError("error in Getting Data", error)
                    //MLLog.logDev(error)
                }
            });
        }
    }
}